
import { ref, onMounted } from "vue";
export default {
    name: "toast",
    props: {
        text: {
            type: String,
            default: "",
        },
    },
    setup() {
        const visible = ref(false);
        onMounted(() => {
            visible.value = true;
        });
        return { visible };
    },
};
